import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { login } from '../../shared/auth/authentication.actions';
import { RouterLink } from '@angular/router';
import { IRootState } from '../app.config';
import { Observable } from 'rxjs';
import { selectLoginErrorMessage } from '../../shared/auth/authentication.reducer';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [ReactiveFormsModule, RouterLink, AsyncPipe],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})
export class LoginComponent {
  loginForm: FormGroup<{ userName: FormControl<string | null>; password: FormControl<string | null>; }> | undefined;
  amAuthed: boolean = false;
  loginErrorMessage: string = '';
  loginErrorMessage$: Observable<string> | undefined;

  constructor(private http: HttpClient,
    private store$: Store<IRootState>
  ) { }

  ngOnInit() {
    this.loginErrorMessage$ = this.store$.select(selectLoginErrorMessage);

    this.loginErrorMessage$.subscribe(data => {
      this.loginErrorMessage = data;
    });

    this.loginForm = new FormGroup({
      userName: new FormControl('', [Validators.required]),
      password: new FormControl('', [Validators.required])
    });
  }

  isAuthed() {
    this.http.get('/api/identity/authenticated').subscribe({
      next: (res) => {
        this.amAuthed = true;
      },
      error: (err) => {
        this.http.get('/api/identity/refresh').subscribe({
          next: (res) => {
            this.amAuthed = true;
          },
          error: (err) => {
            this.amAuthed = false;
          }
        });
      }
    });
  }

  submit() {
    if (this.loginForm?.valid) {
      if (this.loginForm.value && this.loginForm.value.userName && this.loginForm.value.password) {
        this.store$.dispatch(login({ userName: this.loginForm.value.userName, password: this.loginForm.value.password }));
      }
    }
  }
}
